const MAX_SOURCE_TEXT_LENGTH = 100;
const INTERNAL_MARKER_REGEX = /\s*\[(?:SEARCH_RESULT_\d+|CRM_RECORD:[^\]]+|MEMORY_\d+)\]/g;
export const cleanSourceText = (text, sourceType) => {
  if (!text || sourceType !== 'CHAT_MESSAGE') return text;
  return text.replace(INTERNAL_MARKER_REGEX, '').trim();
};
export const cleanAndTruncateSourceText = (text, sourceType) => {
  if (!text || sourceType !== 'CHAT_MESSAGE') return text;
  const cleaned = text.replace(INTERNAL_MARKER_REGEX, '').trim();
  if (cleaned.length <= MAX_SOURCE_TEXT_LENGTH) return cleaned;
  return `${cleaned.slice(0, MAX_SOURCE_TEXT_LENGTH)}…`;
};